const Constantes = window.config.Constantes;

const BtnGoogle = () => {
  document.body.classList.add("googleBtn");
  const $divGoogle = document.querySelector('.googlepay');
  if (!$divGoogle)
    return;
  const $p = document.createElement("span");
  const $p2 = document.createElement("span");
  $p.innerHTML = 'O bien';
  $p2.innerHTML = Constantes.LeyendaPrecioSWG;
  $p2.style.fontSize = "13px";
  $divGoogle.appendChild($p);
  window.GoogleSubscribe.drawButton('googlepay');
  $divGoogle.appendChild($p2);
};

module.exports = {
  BtnGoogle
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/helpers/SubscribeWithGoogleHelper.js